import { SessionStoreState/*, SessionActionType*/ } from '../session/types';
import SetStorageComponent,
{ SetJsonStorageComponent, GetStorageComponent } from '../../utils/storage';

export default function user(state: any = SessionStoreState, action: any) {
  switch (action.type) {
    case 'FETCH_USER_INFO':
      SetStorageComponent('userinfo', JSON.stringify(action.payload));
      return {
        ...state,
        user: {
          ...state,
          ...action.payload
        }
      };
    case 'NEW_COURSE_ENROLL':
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload.user
        }
      };
    case 'SHOW_WELCOME_MSG':
      const userInfo = GetStorageComponent('userinfo');
      if (userInfo != null) {
        const userInfoData = JSON.parse(userInfo);
        userInfoData.showWelcome = action.payload.user.showWelcome;
        SetJsonStorageComponent('userinfo', userInfoData);
      }
      return {
        ...state,
        user: {
          ...state.user,
          showWelcome: action.payload.user.showWelcome
        }
      };
    default:
      return state;
  }
}
